export default __webpack_public_path__ + "assets/b62491cbe0427dbe6725344786be98e5.png";